import React from 'react'
import { CTAButton } from '../CTAButton'
import { CTALink, IProps as ICTAProps } from '../CTALink'
import { ICard, IProps } from './index'
import { CardRounded } from './Cards/Rounded'
import { CardSharp } from './Cards/Sharp'

export const Card: React.FC<IProps> = ({ cta, title, openMessenger, ...cardProps }: IProps) => {
  const openIntercomMessenger = (e: React.MouseEvent) => {
    e.preventDefault()
    window.Intercom('showNewMessage')
  }

  const ComponentWrapper: React.FC<{ cta?: ICTAProps }> = ({ cta, ...props }) => {
    if (cta && openMessenger)
      return <CTAButton {...cta} {...props} onClick={openIntercomMessenger} />
    if (cta) return <CTALink {...cta} {...props} wide />
    return <React.Fragment {...props} />
  }

  const CardComponent = ({ type = 'rounded', ...props }: ICard) => {
    switch (type) {
      case 'rounded':
        return <CardRounded {...props} />
      case 'sharp':
        return <CardSharp {...props} />
      default:
        return null
    }
  }

  return (
    <ComponentWrapper cta={cta} key={title}>
      <CardComponent {...cardProps} title={title} cta={cta} />
    </ComponentWrapper>
  )
}
